var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-message"},_vm._l((_vm.errors),function(error){return _c('div',{key:error,staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_c('div',{staticClass:"alert-body"},[_vm._v(_vm._s(error))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }